<template>
    <div class="news__section">

        <div class="head__text__col" v-bind:style="{ backgroundImage: image_url('left') }">
            <p class="red">LATEST</p>
            <p class="white">NEWS</p>
        </div>

        <news-slider :news="this.news"></news-slider>

        <div class="right__img" v-bind:style="{ backgroundImage: image_url('right') }"></div>
    </div>
</template>
<script>
    export default {
        data(){
            return {}
        },
        props: ['news', 'left_image', 'right_image'],
        mounted(){},
        methods: {
            image_url(position){
                if(position === 'left') return "url('" + this.left_image.media_URL + "')"
                if(position === 'right') return "url('" + this.right_image.media_URL + "')"
                
            }
        }
    }
</script>
<style lang="scss" scoped>

    .news__section{
        // background: #5C2D90;
        background: linear-gradient(180deg, #2A1542 0%, #000000 100%);
        // height: calc(100% - 64px);
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: row;

        .head__text__col{

            width: 100%;
            min-width: 640px;
            // max-width: 640px;
            height: 100%;

            display: flex;
            flex-direction: column;
            justify-content: flex-end;

            // background: url('/images/news/left.webp');
            background-size: cover;
            // background-position: 0 0;
            background-position: 55% 0;
            background-repeat: no-repeat;
            position: relative;

            &:after{
                content: ' ';
                position: absolute;
                width: 100%;
                height: 100%;
                left: 0;
                right: 0;
                top: 0;
                bottom: 0;
                background-color: rgba(0,0,0,.5);
                z-index: 1;

                border-right: 1px solid #ED1163;
            }


            .red{
                font-family: 'DIN Next LT Pro Medium', Tahoma, Verdana, sans-serif;
                font-style: normal;
                font-weight: 700;
                font-size: 50px;
                line-height: 50px;

                margin:0;
                margin-left: 92px;
                margin-right: 86px;

                color: #ED1163;
                z-index: 2;
            }

            .white{
                font-family: 'DIN Next LT Pro Medium', Tahoma, Verdana, sans-serif;
                font-style: normal;
                font-weight: 500;
                font-size: 150px;
                line-height: 150px;
                
                margin:0;
                // margin-left: 92px;
                margin-left: 84px;
                margin-right: 8px;
                margin-bottom: 64px;
                
                color: #FFFFFF;
                z-index: 2;
            }
        }

        .right__img{
            // width: 168px;
            min-width: 168px;
            height: 100%;

            // background: url('/images/news/right.webp') no-repeat;
            background-position: top;
            background-repeat: no-repeat;
            position: relative;

            margin-left: auto;
            margin-right: 0;
            border-left: 1px solid #ED1163;
        }
    }

    @media screen and (max-width: 1750px) {

        .news__section{

            .head__text__col{
                width: 100%;
                min-width: 168px;

                .red, .white{
                    display: none;
                }
            }

        }

    }

    @media screen and (max-width: 1450px) {
        .news__section{
            
            .head__text__col{
                min-width: initial;
            }

            .right__img{
                width: 100%;
                min-width: initial;
            }

        }
    }

    @media screen and (max-width: 836px) {

        .news__section{
            flex-direction: column;
            background: #000;

            .head__text__col, .right__img{
                display: none;
            }

            .news__slider{
                background: black;
            }

        }

    }

</style>